export default __webpack_public_path__ + "static/media/Banner-cic-2-agenda.8a45f5a4.jpg";